import FileSaver from 'file-saver';

export default (data, fileName) => FileSaver.saveAs(data, fileName);
